import { useIntl } from "react-intl";
import { clsx } from "clsx";
import React, { useEffect, useRef } from "react";

export interface DotLoaderProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  autofocus?: boolean;
  dotCount?: 3 | 5;
  color?: "thematic" | "white";
  size?: "small" | "large";
  inline?: boolean;
}

export default function DotLoader({
  className,
  autofocus,
  dotCount = 5,
  color = "thematic",
  size = "large",
  inline = false,
  ...rest
}: DotLoaderProps) {
  const intl = useIntl();
  const loaderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (autofocus) {
      loaderRef.current!.focus();
    }
  }, [autofocus]);

  const Tag = inline ? "span" : "div";

  return (
    <Tag
      className={clsx(
        "vst-dot-loader",
        `vst-dot-loader-size-${size}`,
        dotCount === 3 && "vst-dot-loader-option-3dot",
        color === "white" && "vst-dot-loader-variant-white",
        className
      )}
      role="img"
      aria-label={intl.formatMessage({ defaultMessage: "Loading" })}
      tabIndex={-1}
      ref={loaderRef}
      {...rest}
    >
      {Array.from({ length: dotCount }).map((_, i) => (
        <div key={i} />
      ))}
    </Tag>
  );
}
